<template>
    <cadastro-simples-list
        endpoint="almox-fornecedor"
        rota-base="/admin/almox-fornecedor"
        titulo="ALMOXARIFADO — FORNECEDORES"
        titulo-singular="Fornecedor"
        :colunas-extras="colunasExtras">
    </cadastro-simples-list>
</template>
<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default {
    components: { CadastroSimplesList },
    data: () => ({
        colunasExtras: [
            { campo: 'cnpj_cpf', label: 'CNPJ / CPF', tipo: 'string' },
            { campo: 'telefone', label: 'Telefone', tipo: 'string' }
        ]
    })
}
</script>
